var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "18px",
    viewBox: "0 0 13 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Lock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Lock",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_lock_5381352_000000",
    fill: "#B7844D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4891499,5.71148725 L11.058763,5.71148725 L11.058763,3.98834427 C11.058763,1.7893114 9.30938829,0 7.15840984,0 L5.84225447,0 C3.69206687,0 1.94190135,1.78850286 1.94190135,3.98759215 L1.94190135,5.71073513 L0.511514382,5.71073513 C0.229163172,5.71073513 0.000718384463,5.94430833 0.000718384463,6.23295607 L0,16.1920648 C0,16.4807313 0.22846318,16.7142857 0.510795998,16.7142857 L12.489204,16.7142857 C12.7715552,16.7142857 13,16.4807125 13,16.1920648 L13,6.2337082 C13,5.94504166 12.7715368,5.71148725 12.489204,5.71148725 L12.4891499,5.71148725 Z M2.96347495,3.98761095 C2.96347495,2.36510263 4.25520599,1.04453591 5.84216251,1.04453591 L7.15831788,1.04453591 C8.74532958,1.04453591 10.0370054,2.36442572 10.0370054,3.98761095 L10.0370054,5.71075393 L2.96332782,5.71148857 L2.96347495,3.98761095 Z M11.9784091,15.6698438 L1.02240234,15.6698438 L1.02240234,6.75600436 L11.9784091,6.75600436 L11.9784091,15.6698438 Z M5.9896649,12.0178886 L5.9896649,13.7865541 C5.9896649,14.0752206 6.21812808,14.308775 6.5004609,14.308775 C6.78279372,14.308775 7.0112569,14.0752018 7.0112569,13.7865541 L7.0112569,12.0178886 C7.83530236,11.787982 8.44309681,11.0167692 8.44309681,10.1022198 C8.44309681,9.00708446 7.57163724,8.11622701 6.50055286,8.11622701 C5.42946848,8.11622701 4.5580089,9.00717848 4.5580089,10.1022198 C4.5580089,11.0166752 5.16580335,11.787888 5.98984882,12.0178886 L5.9896649,12.0178886 Z M6.5004609,9.16149625 C7.00838777,9.16149625 7.42076915,9.58383466 7.42076915,10.102389 C7.42076915,10.6216766 7.00767049,11.0432817 6.5004609,11.0432817 C5.99253402,11.0432817 5.58015265,10.6209433 5.58015265,10.102389 C5.58015265,9.58310133 5.99253402,9.16149625 6.5004609,9.16149625 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.1c896880f545d7a1b1013e54e561192b.svg";
export { ForwardRef as ReactComponent };